import React from "react"
import {FaEnvelope as Mail, FaGithub as Github, FaLinkedin as Linkedin, FaTwitter as Twitter,} from "react-icons/fa"
import Nav from "react-bootstrap/Nav"

export default props => (
    <footer className={"footer"}>

        <Nav id="externalNavbarMini"
             className="navbar-dark justify-content-center flex-grow-0 mb-2 d-flex d-lg-none">
            <Nav.Link className="icon mx-1 " href="mailto://blauigris@gmail.com">
                <Mail/>
            </Nav.Link>
            <Nav.Link className="icon mx-1 " href="https://twitter.com/blauigris">
                <Twitter/>
            </Nav.Link>
            <Nav.Link className="icon mx-1 " href="https://es.linkedin.com/in/blauigris">
                <Linkedin/>
            </Nav.Link>
            <Nav.Link className="icon mx-1 " href="https://github.com/blauigris">
                <Github/>
            </Nav.Link>

        </Nav>
        <p className={"small"} style={{textAlign: "center"}}>Designed and built by <a
            href="https://github.com/blauigris/v3">blauigris</a>,
            heavily inspired by <a
                href="https://github.com/bchiang7/v4">Brittany Chiang</a> and <a
                href="https://github.com/Mr404Found/gatsby-starter-profile-site">Mr404Found</a></p>

    </footer>
)

// mx-2 h1 d-block d-sm-block d-md-block d-lg-block d-xl-none"